import { SECTOR } from "../consts/layers";
import { getRedirectToRouteCode } from "./routeConfig";
import { isRedirectionRouteCode } from "./routes";
import { Postcode } from "./postcode";
import { groupPostcodes } from "./lookUpTables";

export const getRedirectConfig = (routeConfig, lookupTables) => {
  const redirectConfig = {};
  for (const { plannedReadyTimeBand, outer: outers } of routeConfig) {
    outers.forEach(({ sector: sectors, postcode: postcodes, routeType }) => {
      sectors?.forEach(({ sector, routeCode }) => {
        if (!isRedirectionRouteCode(routeCode)) return;

        if (!redirectConfig[routeCode]) redirectConfig[routeCode] = {};
        if (!redirectConfig[routeCode][sector])
          redirectConfig[routeCode][sector] = {
            routeCode: null,
          };

        redirectConfig[routeCode][sector].routeCode = getRedirectToRouteCode({
          routeConfig,
          planType: routeType,
          selectedTimeBand: plannedReadyTimeBand,
          postcode: sector,
          minLevel: SECTOR,
        });

        const postcodes = groupPostcodes(lookupTables.POSTCODE)[sector];
        postcodes.forEach((postcode) => {
          const sectorRedirect = redirectConfig[routeCode][sector].routeCode;
          const postcodeRedirect = getRedirectToRouteCode({
            routeConfig,
            planType: routeType,
            selectedTimeBand: plannedReadyTimeBand,
            postcode,
          });
          if (sectorRedirect !== postcodeRedirect)
            redirectConfig[routeCode][sector][postcode] = postcodeRedirect;
        });
      });

      postcodes?.forEach(({ postcode, routeCode }) => {
        if (!isRedirectionRouteCode(routeCode)) return;

        const sector = Postcode.toSector(postcode);
        if (!redirectConfig[routeCode]) redirectConfig[routeCode] = {};
        if (!redirectConfig[routeCode][sector])
          redirectConfig[routeCode][sector] = {
            routeCode: null,
          };

        const sectorRedirect = redirectConfig[routeCode][sector].routeCode;
        const postcodeRedirect = getRedirectToRouteCode({
          routeConfig,
          planType: routeType,
          selectedTimeBand: plannedReadyTimeBand,
          postcode,
        });

        if (sectorRedirect !== postcodeRedirect)
          redirectConfig[routeCode][sector][postcode] = postcodeRedirect;
      });
    });
  }
  return redirectConfig;
};

export const applyChangeToRedirectConfig = ({
  routeConfig,
  redirectConfig,
  change,
}) => {
  redirectConfig = cloneWithoutOuter({ redirectConfig, change });

  for (const { plannedReadyTimeBand, outer: outers } of routeConfig) {
    const { sector: sectors, postcode: postcodes } =
      outers.find(
        ({ outer, routeType }) =>
          outer === change.outer && routeType === change.planType
      ) || {};

    sectors?.forEach(({ sector, routeCode }) => {
      if (!isRedirectionRouteCode(routeCode)) return;

      if (!redirectConfig[routeCode]) redirectConfig[routeCode] = {};
      if (!redirectConfig[routeCode][sector])
        redirectConfig[routeCode][sector] = {
          routeCode: null,
        };

      redirectConfig[routeCode][sector].routeCode = getRedirectToRouteCode({
        routeConfig,
        planType: change.planType,
        selectedTimeBand: plannedReadyTimeBand,
        postcode: sector,
        minLevel: SECTOR,
      });
      change.postcodes[sector].forEach((postcode) => {
        const sectorRedirect = redirectConfig[routeCode][sector].routeCode;
        const postcodeRedirect = getRedirectToRouteCode({
          routeConfig,
          planType: change.planType,
          selectedTimeBand: plannedReadyTimeBand,
          postcode,
        });
        if (sectorRedirect !== postcodeRedirect)
          redirectConfig[routeCode][sector][postcode] = postcodeRedirect;
      });
    });

    postcodes?.forEach(({ postcode, routeCode }) => {
      const sector = Postcode.toSector(postcode);
      if (!isRedirectionRouteCode(routeCode)) return;

      if (!redirectConfig[routeCode]) redirectConfig[routeCode] = {};
      if (!redirectConfig[routeCode][sector])
        redirectConfig[routeCode][sector] = {
          routeCode: null,
        };

      const sectorRedirect = redirectConfig[routeCode][sector].routeCode;
      const postcodeRedirect = getRedirectToRouteCode({
        routeConfig,
        planType: change.planType,
        selectedTimeBand: plannedReadyTimeBand,
        postcode,
      });

      if (sectorRedirect !== postcodeRedirect)
        redirectConfig[routeCode][sector][postcode] = postcodeRedirect;
    });
  }
  return redirectConfig;
};

const cloneWithoutOuter = ({ redirectConfig, change }) => {
  const clone = {};
  Object.keys(redirectConfig).forEach((redirectionRouteCode) => {
    if (redirectionRouteCode[0] === change.planType)
      Object.keys(redirectConfig[redirectionRouteCode]).forEach((sector) => {
        if (change.sectors.includes(sector)) return;
        if (!clone[redirectionRouteCode]) clone[redirectionRouteCode] = {};
        clone[redirectionRouteCode][sector] =
          redirectConfig[redirectionRouteCode][sector];
      });
    else clone[redirectionRouteCode] = redirectConfig[redirectionRouteCode];
  });
  return clone;
};

export const getRedirectForPostcode = ({
  redirectConfig,
  redirectionRouteCode,
  postcode,
}) => {
  const sectorConfig = redirectConfig[redirectionRouteCode]?.[
    Postcode.toSector(postcode)
  ] || { routeCode: null };
  const postcodeRedirect = sectorConfig[postcode];
  if (postcodeRedirect !== undefined) return postcodeRedirect;
  else return sectorConfig.routeCode;
};
